import React, { useState } from "react";

import "./product-tile.scss";

import cn from "classnames";
import { urlFor } from "../utils/utils";
import { getImageDimensions } from "@sanity/asset-utils";
import { Icons } from "./icons";
import { App } from "../globals";
import { Tags } from "./tags";

interface IProps {
  image: string;
  title: string;
  description: string;
  index: number;
  info?: string;
  link?: string;
  tags?: string[];
  apps?: App[];
}

export const ProductTile = ({
  image,
  title,
  description,
  info,
  link,
  index,
  tags,
  apps,
}: IProps) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  let { width, height, aspectRatio } = getImageDimensions(image);
  return (
    <a className="product-tile--link" href={link || ""}>
      <div
        className={cn(
          "product-tile",
          {
            "product-tile-loaded": imgLoaded,
          },
          {
            "product-tile--clickable": link,
          }
        )}
        style={{ transitionDelay: `${index}00ms` }}
      >
        <div className="product-tile--image">
          <img
            width={width}
            height={height}
            style={{ aspectRatio: `${width} / ${height}` }}
            src={urlFor(image).width(800).quality(100).format("webp").url()}
            alt={title}
            onLoad={() => {
              setImgLoaded(true);
            }}
          />
        </div>
        <Icons className="product-tile--icons" apps={apps || []} />
        <div className="product-tile--title">{title}</div>
        <div className="product-tile--description">{description}</div>
        <div className="product-tile--info">{info}</div>
        <Tags tags={tags || []} />
      </div>
    </a>
  );
};
